module.exports = __webpack_public_path__ + "img/moon_shrine_small.177a8ecc.png";